export const getLanguageName = (languageCode: string): string => {
  const languageMap: { [key: string]: string } = {
    'es': 'Español',
    'en': 'Inglés',
    'fr': 'Francés',
    'de': 'Alemán',
    'it': 'Italiano',
    'pt': 'Portugués',
    'ca': 'Catalán',
    'eu': 'Euskera',
    'gl': 'Gallego',
    'ar': 'Árabe',
    'zh': 'Chino',
    'ja': 'Japonés',
    'ko': 'Coreano',
    'ru': 'Ruso',
    'hi': 'Hindi',
    'bn': 'Bengalí',
    'ur': 'Urdu',
    'fa': 'Persa',
    'tr': 'Turco',
    'nl': 'Neerlandés',
    'sv': 'Sueco',
    'da': 'Danés',
    'no': 'Noruego',
    'fi': 'Finés',
    'pl': 'Polaco',
    'cs': 'Checo',
    'sk': 'Eslovaco',
    'hu': 'Húngaro',
    'ro': 'Rumano',
    'bg': 'Búlgaro',
    'hr': 'Croata',
    'sr': 'Serbio',
    'sl': 'Esloveno',
    'et': 'Estonio',
    'lv': 'Letón',
    'lt': 'Lituano',
    'mt': 'Maltés',
    'el': 'Griego',
    'he': 'Hebreo',
    'th': 'Tailandés',
    'vi': 'Vietnamita',
    'id': 'Indonesio',
    'ms': 'Malayo',
    'tl': 'Tagalo',
    'sw': 'Suajili',
    'af': 'Afrikáans',
    'zu': 'Zulú',
    'xh': 'Xhosa',
    'yo': 'Yoruba',
    'ig': 'Igbo',
    'ha': 'Hausa',
    'am': 'Amárico',
    'so': 'Somalí',
    'ku': 'Kurdo',
    'az': 'Azerbaiyano',
    'ka': 'Georgiano',
    'hy': 'Armenio',
    'ky': 'Kirguís',
    'uz': 'Uzbeko',
    'tk': 'Turcomano',
    'mn': 'Mongol',
    'ne': 'Nepalí',
    'si': 'Cingalés',
    'my': 'Birmano',
    'km': 'Jemer',
    'lo': 'Lao',
    'ta': 'Tamil',
    'te': 'Telugu',
    'kn': 'Canarés',
    'ml': 'Malayalam',
    'gu': 'Gujarati',
    'pa': 'Panyabí',
    'or': 'Oriya',
    'as': 'Asamés',
    'mr': 'Maratí',
    'sa': 'Sánscrito',
    'bo': 'Tibetano',
    'dz': 'Dzongkha',
    'ug': 'Uigur',
    'kk': 'Kazajo',
    'tg': 'Tayiko',
    'ps': 'Pastún',
    'sd': 'Sindhi',
    'ckb': 'Kurdo Sorani',
    'arc': 'Arameo',
    'cop': 'Copto',
    'gez': 'Ge\'ez',
    'syr': 'Siríaco',
    'akk': 'Acadio',
    'sum': 'Sumerio',
    'xcl': 'Armenio Clásico',
    'chu': 'Eslavo Eclesiástico',
    'grc': 'Griego Antiguo',
    'lat': 'Latín',
    'ang': 'Inglés Antiguo',
    'fro': 'Francés Antiguo',
    'goh': 'Alto Alemán Antiguo',
    'non': 'Nórdico Antiguo',
    'got': 'Gótico',
    'sga': 'Irlandés Antiguo',
    'owl': 'Galés Antiguo',
    'egy': 'Egipcio Antiguo',
    'hit': 'Hitita',
    'xlu': 'Luvita',
    'pal': 'Persa Medio',
    'peo': 'Persa Antiguo',
    'ave': 'Avestan',
    'san': 'Sánscrito',
    'pali': 'Pali',
    'pra': 'Prakrit',
    'inc': 'Indoario',
    'ira': 'Iranio',
    'cel': 'Celta',
    'gem': 'Germánico',
    'itc': 'Itálico',
    'ine': 'Indoeuropeo',
    'afa': 'Afroasiático',
    'sem': 'Semítico',
    'ber': 'Bereber',
    'cus': 'Cusita',
    'om': 'Oromo',
    'ti': 'Tigriña',
    'aa': 'Afar',
    'ss': 'Siswati',
    'st': 'Sesoto',
    'tn': 'Setswana',
    'ts': 'Xitsonga',
    've': 'Tshivenda',
    'nr': 'Ndebele del Sur',
    'nd': 'Ndebele del Norte',
    'sn': 'Shona',
    'rw': 'Kinyarwanda',
    'rn': 'Kirundi',
    'lg': 'Luganda',
    'ak': 'Akan',
    'ee': 'Ewe',
    'tw': 'Twi',
    'ff': 'Fula',
    'wo': 'Wolof',
    'dy': 'Dyula',
    'bm': 'Bambara',
    'sg': 'Sango',
    'ln': 'Lingala'
  };

  return languageMap[languageCode.toLowerCase()] || languageCode;
};

export const getTomoMultiplier = (tipoTomo: 'individual' | 'doble' | 'triple' | 'multiple', config: any): number => {
  switch (tipoTomo) {
    case 'individual':
      return config.multiplicadorTomoIndividual || 1;
    case 'doble':
      return config.multiplicadorTomoDoble || 2;
    case 'triple':
      return config.multiplicadorTomoTriple || 3;
    case 'multiple':
      return config.multiplicadorTomoMultiple || 5;
    default:
      return 1;
  }
};